<div class="comunicado" *ngIf="comunicado">
    <header class="cabecera">
        <h3>{{ comunicado.asunto }}</h3>
        <span class="meta">CNC Dental · {{ comunicado.fecha | date:'dd/MM/yy HH:mm' }}</span>
    </header>
    <div class="texto" *ngIf="comunicado.texto">{{ comunicado.texto }}</div>
    <div class="adjuntos" *ngIf="comunicado.adjuntos?.length">
        <ng-container *ngFor="let a of comunicado.adjuntos">
            <img *ngIf="esImagen(a) && miniaturas[a.id]; else chip" class="miniatura" [src]="miniaturasSeguras[a.id]"
                 [alt]="a.nombreFicheroOriginal" [matTooltip]="a.nombreFicheroOriginal" (click)="ampliar(a)">
            <ng-template #chip>
                <button mat-stroked-button type="button" class="chip-adjunto" (click)="descargar(a)">
                    <mat-icon>attach_file</mat-icon>
                    {{ a.nombreFicheroOriginal }} ({{ tamano(a.tamano) }})
                </button>
            </ng-template>
        </ng-container>
    </div>
    <p class="aviso" *ngIf="conEnlaceConsulta">
        Este es un comunicado de CNC Dental. Si tienes alguna duda,
        <button type="button" class="enlace" (click)="abrirConsulta.emit()">abre una consulta</button>.
    </p>
</div>
